<template>
  <v-app-bar app clipped-left fixed color="primary" dark>
    <slot name="BtnBack"></slot>

    <v-toolbar-title class="mx-2">{{ functionTitle }}</v-toolbar-title>
    <v-spacer />
    <span>
      <v-icon size="20">fa-user</v-icon>
      <span class="mx-3 text-body-2">{{ userName }}</span>
    </span>

    <slot name="Notification"></slot>

    <v-menu left bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item style="height: 35px; min-height: 35px" @click="goMenu">
          <v-list-item-icon class="mt-1 mr-1">
            <v-icon color="primary">mdi-menu</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="subtitle-1">Menu</v-list-item-title>
        </v-list-item>
        <v-list-item style="height: 35px; min-height: 35px" @click="signOut">
          <v-list-item-icon class="mt-1 mr-1">
            <v-icon color="primary">mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="subtitle-1">Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',

  computed: {
    functionTitle: {
      get() {
        return this.$store.getters.functionTitle + ' (' + process.env.VUE_APP_STAGE + ')'
      },
    },
    userName: {
      get() {
        return this.$store.getters.userName
      },
    },
  },

  methods: {
    async signOut() {
      await this.$store.dispatch('doSignOut')
      this.$router.push({ name: 'SignIn' }).catch(() => {})
    },
    goMenu() {
      this.$router.push({ name: 'TopMenu' }).catch(() => {})
    },
  },
}
</script>
